<template>
    <div class="q-pa-md">
        <div class="row">
            <div class="col-12">
                <div class="text-center">
                    <q-icon name="mdi-minus" size="md" style="cursor: pointer;" color="primary"
                        @click="AnteriorPagina"></q-icon>
                    {{ page }} /{{ numPages }}
                    <q-icon name="mdi-plus" size="md" style="cursor: pointer;" color="primary"
                        @click="SiguientePagina"></q-icon>
                </div>
            </div>
            <div style="width: 100%">
                <pdf ref="pdf" :src="pdfBase64" :page="page" :rotate="rotate" @progress="loadedRatio = $event"
                    @num-pages="numPages = $event" @link-clicked="page = $event"></pdf>
            </div>
        </div>
    </div>
</template>

<script>
import { generarContratoPDF } from '../PDF/ContratoPDF.js' // Ajusta esta ruta

import { QSpinnerClock } from 'quasar'
import pdf from 'vue-pdf';
import axios from 'axios'

export default {
    components: {
        pdf: pdf
    },
    name: 'VisualizadorPDF',
    data() {
        return {
            pdfUrl: null,
            pdfDoc: null,
            loadedRatio: 0,
            page: 1,
            numPages: 0,
            rotate: 0,
            logoBase64: ''
        }
    },
    mounted() {
    },
    created() {
        this.Iniciales()
    },
    computed: {
        pdfBase64() {
            return this.$store.state.auth.storeBase64Contrato;
        },
        contrato() {
            return this.$store.state.auth.objetoContrato
        }

    },
    methods: {
        async Iniciales() {
            this.$q.loading.show({
                spinner: QSpinnerClock,
                spinnerColor: 'primary',
                spinnerSize: 90,
                message: 'Creando contrato, espere..',
            })
            await this.VerContrato();
            this.$q.loading.hide()
        },

        async VerContrato() {
            console.log(this.contrato)
            try {
                let datosFiscales = await this.obtenerDatosFiscales()
                let datosLegales = await this.obtenerDatosLegales()
                let domicilioFiscal = await this.obtenerDomicilioFiscal()
                let datosBancarios = await this.obtenerDatosBancarios()

                console.log(datosFiscales)
                console.log(datosLegales)
                console.log(domicilioFiscal)
                console.log(datosBancarios)

                if (datosFiscales == false) {
                    return this.$q.notify({ type: 'negative', position: 'top-right', message: 'El cliente no cuenta con los datos fiscales completos.' })
                }
                if (datosLegales == false) {
                    return this.$q.notify({ type: 'negative', position: 'top-right', message: 'El cliente no cuenta con los datos legales completos.' })
                }
                if (domicilioFiscal == false) {
                    return this.$q.notify({ type: 'negative', position: 'top-right', message: 'El cliente no cuenta con los datos de su domicilio fiscal completos.' })
                }
                if (datosBancarios == false) {
                    return this.$q.notify({ type: 'negative', position: 'top-right', message: 'Debera completar los datos bacarios de la empresa en el modulo de configuración.' })
                }

                let base64 = ''
                base64 = await generarContratoPDF(this.contrato, datosFiscales, datosLegales, domicilioFiscal, datosBancarios);
                this.$store.state.auth.storeBase64Contrato = 'data:application/pdf;base64,' + base64.split(',')[1];
            } catch (error) {
                console.log(error)
            }
        },
        SiguientePagina() {
            let paginas = this.numPages;
            if (this.page < paginas) {
                this.page++;
            } else {
                // this.page = 1;
            }
        },

        AnteriorPagina() {
            let paginas = this.numPages;
            if (this.page > paginas) {
                this.page--;
            } else {
                this.page = 1;
            }
        },

        async obtenerDatosLegales() {
            try {
                const res = await axios.get('Configuracion/GetDatosLegalesPorCliente/' + this.contrato.id_cliente)

                if (res.data._id != null) {
                    return res.data
                } else {
                    return false
                }

            } catch (err) {
                console.error('Error al obtener perfil:', err)
            }
        },
        async obtenerDatosFiscales() {
            try {
                const res = await axios.get('Configuracion/GetDatosFiscalesPorId/' + this.contrato.id_cliente)

                if (res.data._id != null) {
                    return res.data
                } else {
                    return false
                }

            } catch (err) {
                console.error('Error al obtener perfil:', err)
            }
        },
        async obtenerDomicilioFiscal() {
            try {
                const res = await axios.get('Configuracion/GetDomicilioPorCliente/' + this.contrato.id_cliente)

                if (res.data._id != null) {
                    return res.data
                } else {
                    return false
                }
            } catch (err) {
                console.error('Error al obtener perfil:', err)
            }
        },
        async obtenerDatosBancarios() {
            try {
                const res = await axios.get('Configuracion/GetEmpresa')

                if (res.data._id != null) {
                    return res.data
                } else {
                    return false
                }
            } catch (err) {
                console.error(err)
            }
        }
    }
}
</script>